export default {
  introTitle: {
    id: 'rm_video_intro_title',
    defaultMessage: 'Mine my Phone: the campaign film',
  },
} as const
